export default __webpack_public_path__ + "static/feminine-da3d53676660d172c7f6be9a9ee4aac0.gltf";